import React                from 'react';
import ReduxAccusedListRow  from './ReduxAccusedListRow';
import StateAccusedListRow  from './StateAccusedListRow';


const AccusedsList = props => {
    
    // Traigo los props
    const { audience, resultForm, tipos } = props;
    
    // Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">IMPUTADOS - RESULTADOS</h6>
                </div>
                <table className="table table-hover table-sm">
                    <thead className="thead-light">
                        <tr>
                            <th className="text-center">Apellido y Nombre</th>
                            <th className="text-center">Tipo y No. Documento</th>
                            <th className="text-center">Resultados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {   resultForm
                                ?
                                    audience.imputadoList?.map(accused => (
                                        <StateAccusedListRow
                                            accused = { accused }
                                            audience = { audience }
                                            key = { `ata${accused.id}` }
                                            tipos = { tipos }
                                        />
                                    ))
                                :
                                    audience.imputadoList?.map(accused => (
                                        <ReduxAccusedListRow
                                            accused = { accused }
                                            audience = { audience }
                                            key = { `ata${accused.id}` }
                                            tipos = { tipos }
                                        />
                                    ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AccusedsList;